var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_c('h5',{staticClass:"Title"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }